module.exports = __webpack_public_path__ + "img/img_photo_default@3x.3981584d.png";